import { Badge, Typography } from "antd";
import { EditableCellType } from "shared/components/dataList/EditableCell";
import { EditableColumnParameters } from "shared/components/dataList/setupEditableCells";
import { ITableColumnURL } from "shared/components/dataListURL/DataListURLTable";
import {
  MarketingMaterialPrintDeliveryOrder,
  PrintOrderTableKeys,
} from "shared/types/salesEnablement/order";

const OrderStatusMap = {
  IN_PROGRESS: {
    color: "blue",
    text: "In Progress",
  },
  COMPLETE: {
    color: "green",
    text: "Complete",
  },
};

const { Link } = Typography;

export type PrintArchiveColumn = ITableColumnURL<
  PrintOrderTableKeys,
  MarketingMaterialPrintDeliveryOrder
> &
  EditableColumnParameters<MarketingMaterialPrintDeliveryOrder>;

export const getColumns = (
  openOrderDetails: (order: MarketingMaterialPrintDeliveryOrder) => void,
): PrintArchiveColumn[] => [
  {
    title: "Order ID",
    dataIndex: "id",
    key: "id",
    render: (_, record) => (
      <Link onClick={() => openOrderDetails(record)}>{record.id}</Link>
    ),
  },
  {
    title: "Order Date",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (_, record) =>
      record?.createdAt
        ? new Date(record?.createdAt).toLocaleDateString("en-US")
        : "-",
  },
  {
    title: "Recipient",
    dataIndex: "recipient",
    key: "recipient",
    render: (_, record) => record?.shippingData?.fullName,
  },
  {
    title: "Estimated Amount",
    dataIndex: "totalAmount",
    key: "estimatedAmount",
    render: (_, record) => record?.totalAmount?.toFixed(2),
  },
  {
    title: "Order Status",
    dataIndex: "orderStatus",
    key: "orderStatus",
    editable: true,
    editableCellType: EditableCellType.Select,
    selectOptions: [
      { key: 0, value: "IN_PROGRESS", text: "In Progress" },
      { key: 1, value: "COMPLETE", text: "Complete" },
    ],
    render: (_, record) => {
      const orderStatus = record.orderStatus ?? "IN_PROGRESS";
      const currentStatus = OrderStatusMap[orderStatus];
      return (
        <span>
          <Badge color={currentStatus?.color ?? "default"} />
          {currentStatus?.text}
        </span>
      );
    },
  },
  {
    title: "Completion Date",
    dataIndex: "completedAt",
    key: "completedAt",
  },
  {
    title: "Completed By",
    dataIndex: "completedBy",
    key: "completedBy",
  },
];
